<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";

  export let state_zip_geojson = [];
  export let evictions = [];

  var geojson;
  let zip_geojson;
  var legend;
  let mymap;

  var zoomed_state;

  let evictions_by_zip = new Map();

  // let evictions_by_zip = d3.group(evictions, d => d.zip);

  $: evictions_by_zip = d3.group(evictions, (d) => d.zip);

  // $:console.log(Array.from(evictions_by_zip).length)

  // ### BEGIN ZIP CODES MAP ### //
  // ### BEGIN ZIP CODES MAP ### //
  // ### BEGIN ZIP CODES MAP ### //
  // ### BEGIN ZIP CODES MAP ### //
  // ### BEGIN ZIP CODES MAP ### //
  // ### BEGIN ZIP CODES MAP ### //

  let zipExtent = d3.extent(
    d3.groups(evictions, (d) => d.zip),
    (d) => d[1].length
  );
  let zipLinearScale = d3.scaleLinear().domain(zipExtent);
  let zipColorScale = zipLinearScale
    .interpolate(d3.interpolateHcl)
    .range([d3.hcl("#a8ddb5"), d3.hcl("#0868ac")]);

  let intervalValues = [];
  let intervalCount = 10;
  let intervalWidth = (zipExtent[1] - zipExtent[0]) / (intervalCount - 1);
  let legendData = [];

  for (let i = zipExtent[0]; i < zipExtent[1] + 1; i += intervalWidth) {
    legendData.push({ value: Math.round(i), color: zipColorScale(i) });
  }

  var mapboxAccessToken =
    "pk.eyJ1IjoiZ3JhY2Vnc3kiLCJhIjoiY2tpN3c3djh1NGxjZTJ4cm16bGdxNHI5ZCJ9.DD9X7XuTcY42PffpEqNo-g";

  onMount(() => {
    mymap = L.map("mapid", {
      minZoom: 9,
      maxZoom: 12,
    }).setView([33.82, -84.3], 10);

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: "mapbox/light-v9",
        tileSize: 512,
        zoomOffset: -1,
        accessToken: mapboxAccessToken,
      }
    ).addTo(mymap);

    zip_geojson = L.geoJson(state_zip_geojson, { style: zip_style })
      .bindPopup(function (layer) {
        let zip = layer.feature.properties.ZCTA5CE10;
        if (!evictions_by_zip.get(parseInt(zip))) {
          return `<b>${zip}</b><br/>This ZIP area has been filtered out`;
        } else {
          let entries = evictions_by_zip.get(parseInt(zip));
          let table = zip_table(entries);
          let county = evictions_by_zip.get(parseInt(zip))[0].county;
          return `<b>Top Addresses in ${zip}</b><br/>${county} County${table}`;
        }
      })
      .addTo(mymap);

    legend.addTo(mymap);
  });

  function zip_style(feature) {
    let zip = feature.properties.ZCTA5CE10;

    // If a zip code area does not have evictions within the query range
    if (!evictions_by_zip.get(parseInt(zip))) {
      return {
        // fillColor: "blue",
        fillColor: "lightgray",
        weight: 0.5,
        opacity: 1,
        color: "white",
        fillOpacity: 0.8,
      };
    }

    return {
      // fillColor: "blue",
      fillColor: zipColorScale(evictions_by_zip.get(parseInt(zip)).length),
      weight: 0.5,
      opacity: 1,
      color: "white",
      fillOpacity: 0.7,
    };
  }

  function compare(a, b) {
    if (a[1].length > b[1].length) {
      return -1;
    }
    if (a[1].length < b[1].length) {
      return 1;
    }
    return 0;
  }

  function zip_table(entries) {
    let evictions_by_street = d3.groups(entries, (d) => d.street);
    let street_sorted = evictions_by_street.sort(compare).slice(0, 10);
    console.log(street_sorted);
    let table_start = `<table style='width:100%;
										margin-top:10px;'>
							<thead>
								<tr>
									<th class="header" style="text-align:left;border-bottom: 1px solid gray;">Street</th>
									<th class="header" style="text-align:left;border-bottom: 1px solid gray;">Count</th>
								<tr/>
							</thead>
							<tbody>`;

    for (let i = 0; i < street_sorted.length; i++) {
      let entry = street_sorted[i];
      let background = i % 2 === 1 ? "#f0f0f0" : "white";
      table_start =
        table_start +
        `<tr style="background:${background}">
						<td class="data">${entry[0]}</td>
						<td class="data">${entry[1].length}</td>
					</tr>`;
    }

    let table = table_start + "</tbody></table>";
    return table;
  }

  // console.log(state_zip_geojson)

  $: if (mymap && evictions_by_zip) {
    zip_geojson.remove();
    zip_geojson = L.geoJson(state_zip_geojson, { style: zip_style })
      .bindPopup(function (layer) {
        let zip = layer.feature.properties.ZCTA5CE10;
        if (!evictions_by_zip.get(parseInt(zip))) {
          return `<b>${zip}</b><br/>This ZIP area has been filtered out`;
        } else {
          let entries = evictions_by_zip.get(parseInt(zip));
          let table = zip_table(entries);
          let county = evictions_by_zip.get(parseInt(zip))[0].county;
          return `<b>Top Addresses in ${zip}</b><br/>${county} County${table}`;
        }
      })
      .addTo(mymap);
  }

  // Legend
  var legend = L.control();

  legend.onAdd = function (map) {
    this._div = L.DomUtil.create("div", "legend"); // create a div with a class "legend"
    this.update();
    return this._div;
  };

  // method that we will use to update the control based on feature properties passed
  legend.update = function (props) {
    let legendSvg = d3
      .select(this._div)
      .append("svg")
      .attr("class", "legend")
      .attr("width", 270)
      .attr("height", 50);

    legendSvg
      .selectAll("rect")
      .data(legendData)
      .enter()
      .append("rect")
      .attr("fill", (d) => d.color)
      .attr("x", (d, i) => i * (250 / legendData.length) + 10)
      .attr("y", 15)
      .attr("height", 15)
      .attr("width", 250 / legendData.length);

    legendSvg
      .selectAll("text")
      .data(legendData)
      .enter()
      .append("text")
      .attr("x", (d, i) => i * (250 / legendData.length) + 10)
      .attr("y", 10)
      .attr("font-size", 8)
      .attr("text-anchor", "middle")
      .text((d, i) => {
        if (i % 2 === 0) {
          return d.value;
        } else {
          return "";
        }
      });

    legendSvg
      .append("text")
      .attr("x", 250 + 10)
      .attr("y", 10)
      .attr("font-size", 8)
      .attr("text-anchor", "middle")
      .text(zipExtent[1]);
  };
</script>

<div id="mapid" />

<style>
  #mapid {
    height: 70vh;
    width: auto;
    margin: 25px;
  }
</style>
